import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export default function Target({ target, isHit, targetRef }) {
  const className = useMemo(() => `target ${isHit ? 'hit' : ''}`, [isHit]);
  const boardStyle = useMemo(() => ({ '--target-color': target.color }), [target.color]);

  return (
    <div ref={targetRef} className={className}>
      <div className="target-board" style={boardStyle}>
        <div className="target-ring ring-outer" />
        <div className="target-ring ring-middle" />
        <div className="target-ring ring-inner" />
        <div className="target-bullseye" />
      </div>
      <span className="target-label">{target.label}</span>
    </div>
  );
}

Target.propTypes = {
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  isHit: PropTypes.bool,
  targetRef: PropTypes.func,
};

